var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsBlockedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 17.583 17.583",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Blocked",
    d: "M8.792,17.583a8.792,8.792,0,1,1,8.792-8.792A8.792,8.792,0,0,1,8.792,17.583Zm0-1.465A7.326,7.326,0,1,0,1.465,8.792,7.326,7.326,0,0,0,8.792,16.118ZM11.937,4.61a.733.733,0,1,1,1.036,1.036L5.646,12.973A.733.733,0,1,1,4.61,11.937Z",
    transform: "translate(17.583) rotate(90)",
    fill: "#787f88",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsBlockedIcon);
export default __webpack_public_path__ + "static/media/settings-blocked-icon.eb01571ba827ab0ff04baca29ddb8b1f.svg";
export { ForwardRef as ReactComponent };